import { render, staticRenderFns } from "./TableTrxComponent.vue?vue&type=template&id=58d1b4c4"
import script from "./TableTrxComponent.vue?vue&type=script&lang=js"
export * from "./TableTrxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports